module.exports = __webpack_public_path__ + "static/media/Calendar-2.f50024d1.png";